var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94283 8.00001L11.8048 5.13801C12.0655 4.87735 12.0655 4.45601 11.8048 4.19535C11.5442 3.93468 11.1228 3.93468 10.8622 4.19535L8.00017 7.05735L5.13817 4.19535C4.8775 3.93468 4.45617 3.93468 4.1955 4.19535C3.93483 4.45601 3.93483 4.87735 4.1955 5.13801L7.0575 8.00001L4.1955 10.862C3.93483 11.1227 3.93483 11.544 4.1955 11.8047C4.3255 11.9347 4.49617 12 4.66683 12C4.8375 12 5.00817 11.9347 5.13817 11.8047L8.00017 8.94268L10.8622 11.8047C10.9922 11.9347 11.1628 12 11.3335 12C11.5042 12 11.6748 11.9347 11.8048 11.8047C12.0655 11.544 12.0655 11.1227 11.8048 10.862L8.94283 8.00001Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 9,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94283 8.00001L11.8048 5.13801C12.0655 4.87735 12.0655 4.45601 11.8048 4.19535C11.5442 3.93468 11.1228 3.93468 10.8622 4.19535L8.00017 7.05735L5.13817 4.19535C4.8775 3.93468 4.45617 3.93468 4.1955 4.19535C3.93483 4.45601 3.93483 4.87735 4.1955 5.13801L7.0575 8.00001L4.1955 10.862C3.93483 11.1227 3.93483 11.544 4.1955 11.8047C4.3255 11.9347 4.49617 12 4.66683 12C4.8375 12 5.00817 11.9347 5.13817 11.8047L8.00017 8.94268L10.8622 11.8047C10.9922 11.9347 11.1628 12 11.3335 12C11.5042 12 11.6748 11.9347 11.8048 11.8047C12.0655 11.544 12.0655 11.1227 11.8048 10.862L8.94283 8.00001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.999fa470141539700a2d986cac28ec63.svg";
export { ForwardRef as ReactComponent };